import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import HalfBox from '../../components/HalfBox';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

class HalfHalfView extends PureComponent {
  render() {
    return (
      <div
        className={
          this.props.rightSideViewVisibilityIndex === 4 ||
          this.props.rightSideViewVisibilityIndex === 5
            ? 'orderViews halfView active'
            : 'orderViews halfView'
        }
      >
        <div
          className='backToOrder thickcon-Left-Chevron'
          onClick={this.props.hideOrder}
        />
        <TransitionGroup className='order-items'>
          {this.props.toggleAnimation ? (
            <CSSTransition
              key={1}
              classNames='example1'
              timeout={{ enter: 500, exit: 500 }}
              component='div'
            >
              <HalfBox
                rightSideViewVisibilityIndex={
                  this.props.rightSideViewVisibilityIndex
                }
                addHalfHalfToOrder={this.props.addHalfHalfToOrder}
                selectedHalfItems={this.props.selectedHalfItems}
                halfItem={this.props.halfItem}
                key='1'
                halfFilter={this.props.halfFilter}
                clearItemsNotAvailableForVariants={
                  this.props.clearItemsNotAvailableForVariants
                }
                whichHalf={this.props.whichHalf}
                menuItems={this.props.menuItems}
                clearOrChangeSize={this.props.clearOrChangeSize}
                itemSizes={this.props.itemSizes}
              />
            </CSSTransition>
          ) : (
            <CSSTransition
              key={2}
              classNames='example1'
              timeout={{ enter: 500, exit: 500 }}
              component='div'
            >
              <HalfBox
                rightSideViewVisibilityIndex={
                  this.props.rightSideViewVisibilityIndex
                }
                addHalfHalfToOrder={this.props.addHalfHalfToOrder}
                selectedHalfItems={this.props.selectedHalfItems}
                halfItem={this.props.halfItem}
                key='2'
                halfFilter={this.props.halfFilter}
                clearItemsNotAvailableForVariants={
                  this.props.clearItemsNotAvailableForVariants
                }
                whichHalf={this.props.whichHalf}
                menuItems={this.props.menuItems}
                clearOrChangeSize={this.props.clearOrChangeSize}
                itemSizes={this.props.itemSizes}
              />
            </CSSTransition>
          )}
        </TransitionGroup>
      </div>
    );
  }
}

HalfHalfView.propTypes = {
  halfItem: PropTypes.any,
  selectedHalfItems: PropTypes.any,
  halfFilter: PropTypes.any,
  toggleAnimation: PropTypes.any,
  hideOrder: PropTypes.any,
  rightSideViewVisibilityIndex: PropTypes.any,
  addHalfHalfToOrder: PropTypes.any,
  clearItemsNotAvailableForVariants: PropTypes.any,
  whichHalf: PropTypes.any,
  menuItems: PropTypes.any,
  clearOrChangeSize: PropTypes.any,
};

export default HalfHalfView;
